import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageSnackComponent } from '../modules/pages/downloads/message-snack/message-snack.component';

@Injectable({
  providedIn: 'root'
})
export class DownloadLogService {

  constructor(    
    private http: HttpClient,
    private _snackBar: MatSnackBar,
  ) { }

  getList(suffurl: string) {
    return this.http.get(suffurl);    
  }

  openSnackBar() {
    this._snackBar.openFromComponent(MessageSnackComponent, {
      // duration:  10000,
      panelClass: ['download-snackbar'],
      horizontalPosition: 'end',
      verticalPosition: 'bottom'
    });
  }

  openSimpleSnackBar(message: string, duration: number = 5000, panelClass: string[] = ['download-snackbar']) {
    this._snackBar.open(message, 'Close', {
      duration: duration,
      panelClass: panelClass,
      horizontalPosition: 'end',
      verticalPosition: 'bottom'
    });
  }

  deleteReport(url:string, id:string){
    return this.http.post(url,id);
  }

}
